import React from "react";
import type {ICommandBarItemProps} from "@fluentui/react";

import styles from "../../constructionCalculationsNew.module.scss"
import IsaacCommandBar from "../../../../components/isaacCommandBar/IsaacCommandBar";

const CalculationCommandBarNew: React.FunctionComponent<{
  hasCalculations: boolean;
  commandBarItems: ICommandBarItemProps[];
  commandBarFarItems: ICommandBarItemProps[] | undefined;
}> = ({hasCalculations, commandBarItems, commandBarFarItems}) => {
  return (
    <>
      {hasCalculations && (
        <div className={styles.commandBar}>
          <IsaacCommandBar
            items={commandBarItems}
            farItems={commandBarFarItems}
          />
        </div>
      )}
    </>
  );
};

export default CalculationCommandBarNew;
